module.exports = __webpack_public_path__ + "img/x-circle-solid.a7f6e698.svg";